<div
  class="wrapper flex border-2"
  [ngClass]="{
    'border-[--primary-500]': data.notificationType === NotificationType.Info,
    'border-green-500': data.notificationType === NotificationType.Success,
    'border-[#FA9401]': data.notificationType === NotificationType.Warning,
    'border-[--error-800]': data.notificationType === NotificationType.Error
  }"
  (mouseenter)="pauseTimer()"
  (mouseleave)="resumeTimer()"
>
  <div>
    <mat-icon class="icon !overflow-visible" [ngStyle]="{ color: notificationColor }">
      {{ notificationIcon }}
    </mat-icon>
  </div>
  <div class="px-4 flex flex-col gap-1 flex-1">
    <div class="font-bold text-sm">{{ data.title }}</div>
    <div class="text-sm text-[#404040]">{{ data.message }}</div>
  </div>

  @if (data.notificationType === NotificationType.Warning || data.notificationType === NotificationType.Error) {
    <div class="text-[--primary-500] cursor-pointer" (click)="close()">
      <mat-icon class="relative -top-1">close</mat-icon>
    </div>
  }

  @if (data.duration) {
    <div class="progress-bar">
      <div
        class="progress"
        [ngStyle]="{
          width: (countDown / data.duration) * 100 + '%',
          'background-color': notificationColor
        }"
      ></div>
    </div>
  }
</div>
